import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  MissingManifestDownloadResponse,
  MissingManifestUIResponse,
} from "../../models/ApiResponse";
import agent from "../../api/agent";
import { MissingManifestResponse } from "../../models/responseModels/missingManifestResponse";

type InitialState = {
  isLoading: boolean;
  missingManifestList: MissingManifestResponse[];
  errorMessage: string | null;
};

const initialState: InitialState = {
  isLoading: false,
  missingManifestList: [],
  errorMessage: null,
};

export const getMissingManifestList =
  createAsyncThunk<MissingManifestUIResponse>(
    "missingManifest/missingManifestResponse",
    async () => {
      const response =
        await agent.MissingManifestAgent.getMissingManifestList();
      return response;
    }
  );

export const downloadMissingManifestDataToCsv = createAsyncThunk<
  MissingManifestDownloadResponse,
  MissingManifestResponse[]
>(
  "missingManifest/downloadCsv",
  async (missingManifestData: MissingManifestResponse[]) => {
    const response =
      await agent.MissingManifestAgent.missingManifestCsvDownload(
        missingManifestData
      );
    return response;
  }
);

export const downloadMissingManifestDataToXlsx = createAsyncThunk<
  Blob,
  MissingManifestResponse[]
>(
  "missingManifest/downloadXlsx",
  async (missingManifestData: MissingManifestResponse[]) => {
    const response =
      await agent.MissingManifestAgent.missingManifestXlsxDownload(
        missingManifestData
      );
    return response;
  }
);

const missingManifestSlice = createSlice({
  name: "missingManifest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMissingManifestList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMissingManifestList.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.isSuccess) {
          state.missingManifestList = action.payload.data;
        } else {
          state.missingManifestList = [];
        }
      })
      .addCase(getMissingManifestList.rejected, (state, action) => {
        state.isLoading = false;
        state.missingManifestList = [];
        state.errorMessage = action.error.message!;
      });
  },
});

export default missingManifestSlice.reducer;
